import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  modalContentContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  displayText: {
    paddingTop: theme.spacing(1),
    color: 'inherit',
  },
}));
